import {CommandClause, CPCLCommand} from "@psdk/frame-father";
import {BasicCPCLArg} from "./basic";

export class CBold extends BasicCPCLArg<CBold> {
  private bold: boolean;

  constructor(options?: {
    /**
     * 是否粗体0：否； 1：是
     */
    bold?: boolean
  }) {
    super();
    this.bold = options?.bold ?? false;
  }

  clause(): CommandClause {
    return CPCLCommand.with(this.header())
      .appendText(this.bold ? "1" : "0")
      .clause();
  }

  header(): string {
    return 'SETBOLD';
  }
}



